export const MapBoxAPIToken: string = 'pk.eyJ1IjoiYXRyaXRlY3Jhc211cyIsImEiOiJja2lmdGxjN2YwbmFkMndxdXk0dHlhNDk1In0.9ioQxSuhItVccb71lEosHQ';